import { render, staticRenderFns } from "./DevApi.vue?vue&type=template&id=04b8f616&scoped=true"
import script from "./DevApi.vue?vue&type=script&lang=js"
export * from "./DevApi.vue?vue&type=script&lang=js"
import style0 from "./DevApi.vue?vue&type=style&index=0&id=04b8f616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8f616",
  null
  
)

export default component.exports